/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetFleetCategory, GetFleetFuelType, GetFleetMotionVector } from '../../../../store/Lookup/lookupSlice';
import useLookupNationality from '../../../../hooks/Lookups/use-Lookup-Nationality';
import { useNavigate } from 'react-router-dom';
import {
  GetEquipmentsModelById,
  GetEquipmentsModelList,
  UpdateEquipmentsModel
} from '../../../../store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { EquipmentsModelSchema } from '../../../ValidationForm/validationSchema';
// import FileList from '../../../Attachments/FileList';
import Loading from '../../../../components/Shared/Loader/Loading';
import FileUpload from '@components/Files/FileUpload';

const EditModel = ({ id }: { id: string }) => {
  const Navigate = useNavigate();
  const [img, setImage] = useState<any[]>([]);
  const [kuroki, setKuroki] = useState<any[]>([]);

  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(GetEquipmentsModelById(id));
  }, [id]);
  useEffect(() => {
    dispatch(GetFleetCategory());
    dispatch(GetFleetFuelType());
    dispatch(GetFleetMotionVector());
    dispatch(GetEquipmentsModelList());
  }, []);

  const { EquipmentsModelList } = useAppSelector(state => state.EquipmentsModel);
  const { FleetCategory, FleetFuelType, FleetMotionVector } = useAppSelector(state => state.Lookup);
  const { EquipmentsModelListById: data, loadingById, errorById } = useAppSelector(state => state.EquipmentsModel);
  const { dataNATIONALITY } = useLookupNationality();

  // console.log(data);

  useEffect(() => {}, [data]);

  useEffect(() => {
    if (data?.image) {
      setImage([{ name: data?.image?.fileName, url: data?.image?.filePath }]);
    }

    if (data?.kuroki) {
      setKuroki([{ name: data?.kuroki?.fileName, url: data?.kuroki?.filePath }]);
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      id: data ? data.id : '',
      name: data ? data.name : '',
      name2: data ? data.name2 : '',
      description: data ? data.description : '',

      parentId: data ? data.parentId : '',

      manufYear: data ? data.manufYear : '',
      barcode: data ? data.barcode : '',
      catagory: data ? data.catagory : '',
      manufCountry: data ? data.manufCountry : '',
      seatsNo: data ? data.seatsNo : '',
      doorsNo: data ? data.doorsNo : '',
      fuelType: data ? data.fuelType : '',
      motionVector: data ? data.motionVector : '',
      horsepower: data ? data.horsepower : '',
      horsepowerTax: data ? data.horsepowerTax : '',
      Img: '',
      IsUpdateIMG: false,
      Kuroki: '',
      IsUpdateKuroki: false
    },
    enableReinitialize: true,
    validationSchema: EquipmentsModelSchema(t),
    onSubmit: values => {
     
      const formData = new FormData();

      formData.append('Id', values.id);
      formData.append('Name', values.name);
      formData.append('Name2', values.name2);
      formData.append('Description', values.description);
      formData.append('ParentId', values.parentId);
      formData.append('ManufYear', values.manufYear || '');
      formData.append('Barcode', values.barcode || '');
      formData.append('Catagory', values.catagory);
      formData.append('ManufCountry', values.manufCountry || '');
      formData.append('SeatsNo', values.seatsNo?.toString() || '0');
      formData.append('DoorsNo', values.doorsNo?.toString() || '0');
      formData.append('FuelType', values.fuelType || '');
      formData.append('MotionVector', values.motionVector || '');
      formData.append('Horsepower', values.horsepower?.toString() || '');
      formData.append('HorsepowerTax', values.horsepowerTax?.toString() || '');
      formData.append('Img', values.Img);
      formData.append('IsUpdateIMG', values.IsUpdateIMG?.toString() || '');

      formData.append('Kuroki', values.Kuroki);
      formData.append('IsUpdateKuroki', values.IsUpdateKuroki?.toString());
    
      dispatch(UpdateEquipmentsModel(formData))
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            Navigate('/FLEETSettings/Model', { replace: true });
            dispatch(GetEquipmentsModelList());
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const handleImageUpload: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setImage(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('Img', newAttachments[0]);
        formik.setFieldValue('IsUpdateIMG', true);
      } else {
        formik.setFieldValue('Img', '');
        formik.setFieldValue('IsUpdateIMG', false);
      }
      return newAttachments;
    });
  };

  const handleKurokiUpload: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setKuroki(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('Kuroki', newAttachments[0]);
        formik.setFieldValue('IsUpdateKuroki', true);
      } else {
        formik.setFieldValue('Kuroki', '');
        formik.setFieldValue('IsUpdateKuroki', false);
      }
      return newAttachments;
    });
  };

  // console.log(formik.values.IsUpdateKuroki);
  // console.log(formik.values.Kuroki);

  return (
    <>
      {/* <Breadcrumb BreadcrumbList={BcrumbList} PageName="EditModel" /> */}

      <Loading loading={loadingById} error={errorById}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={!!(formik.touched.name && formik.errors.name)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Manufacturer')}</label>
                <Form.Select
                  className='form-select'
                  name='parentId'
                  onChange={formik.handleChange}
                  value={formik.values.parentId || ''}
                  isInvalid={!!(formik.touched.parentId && formik.errors.parentId)}
                >
                  <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {EquipmentsModelList &&
                    EquipmentsModelList?.filter(f => f.parentId === null)?.map((item, idx) => (
                      <option key={++idx} value={item.id}>
                        {i18n.language === 'ar' ? item.name2 : item.name}
                      </option>
                    ))}
                </Form.Select>
                {formik.errors.parentId && formik.touched.parentId && <div>{formik.errors.parentId}</div>}
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Catagory')}</label>
                <Form.Select
                  className='form-select'
                  name='catagory'
                  onChange={formik.handleChange}
                  value={formik.values.catagory || ''}
                  isInvalid={!!(formik.touched.catagory && formik.errors.catagory)}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {FleetCategory &&
                    FleetCategory?.map((item: any, idx) =>
                      item.list?.map((list: any) => (
                        <option key={++idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.catagory}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Transmission')}</label>
                <Form.Select
                  className='form-select'
                  name='motionVector'
                  onChange={formik.handleChange}
                  value={formik.values.motionVector || ''}
                  isInvalid={!!(formik.touched.motionVector && formik.errors.motionVector)}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {FleetMotionVector &&
                    FleetMotionVector?.map((item: any, idx) =>
                      item.list?.map((list: any) => (
                        <option key={++idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.motionVector}</Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Year_of_Manufacture')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='manufYear'
                  onChange={formik.handleChange}
                  value={formik.values.manufYear || ''}
                  isInvalid={!!(formik.touched.manufYear && formik.errors.manufYear)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.manufYear}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('State_of_Manufacture')}</label>
                <Select
                  classNamePrefix='react-select'
                  isRtl
                  isSearchable={true}
                  options={dataNATIONALITY}
                  onChange={(option: any) => formik.setFieldValue('manufCountry', option.value)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  value={dataNATIONALITY?.find((f: any) => f?.value === formik?.values?.manufCountry)}
                />
                {formik.errors.manufCountry && formik.touched.manufCountry && (
                  <div style={{ color: 'red' }}>{formik.errors.manufCountry}</div>
                )}
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Type_of_Fuel')}</label>
                <Form.Select
                  className='form-select'
                  name='fuelType'
                  onChange={formik.handleChange}
                  value={formik.values.fuelType || ''}
                  isInvalid={!!(formik.touched.fuelType && formik.errors.fuelType)}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {FleetFuelType &&
                    FleetFuelType?.map((item: any, idx) =>
                      item.list?.map((list: any) => (
                        <option key={++idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>{formik.errors.fuelType}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Barcodes')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='barcode'
                  onChange={formik.handleChange}
                  value={formik.values.barcode || ''}
                  isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-2'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Number_of_Seats')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  name='seatsNo'
                  onChange={formik.handleChange}
                  value={formik.values.seatsNo || ''}
                  isInvalid={!!(formik.touched.seatsNo && formik.errors.seatsNo)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.seatsNo}</Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-2'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Number_of_Doors')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  name='doorsNo'
                  onChange={formik.handleChange}
                  value={formik.values.doorsNo || ''}
                  isInvalid={!!(formik.touched.doorsNo && formik.errors.doorsNo)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.doorsNo}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-2'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Horsepower')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  name='horsepower'
                  onChange={formik.handleChange}
                  value={formik.values.horsepower || ''}
                  isInvalid={!!(formik.touched.horsepower && formik.errors.horsepower)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.horsepower}</Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Horsepower_Tax')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  name='horsepowerTax'
                  onChange={formik.handleChange}
                  value={formik.values.horsepowerTax || ''}
                  isInvalid={!!(formik.touched.horsepowerTax && formik.errors.horsepowerTax)}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.horsepowerTax}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Image')}</label>
                <FileUpload attachments={img} setAttachments={handleImageUpload} multiple={false} />
              </div>
            </div>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('الرسم التخطيطي - Kuroki ')}</label>
                <FileUpload attachments={kuroki} setAttachments={handleKurokiUpload} multiple={false} />
              </div>
            </div>
          </div>

          <div className='text-center'>
            <div className='d-flex justify-content-between gap-2'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-save fa-lg fa-fw me-2'></i>
                )}
                {t('Save')}
              </button>
              <button type='button' className='btn btn-lg  btn-default mb-1 w-100' data-bs-dismiss='modal'>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default EditModel;
